
export default {
  methods: {
    permissionFn(type) {
      switch (type) {
        // 10 管理员
        case 'admin':
          return this.$store.state.global.previllage === 10
        // previllage: 1,2,10 有读权限就行
        case 'read':
          return [1, 2, 10].includes(this.$store.state.global.previllage)
        // previllage:2 10 有读写权限
        case 'write':
          return [2, 10].includes(this.$store.state.global.previllage)
      }
    }
  }
}
